import React, { Component } from 'react';
import { Button, Row, Col } from 'react-bootstrap';

import FileField from './FileField';

require(`../assets/${process.env.PAGE}/css/document-field.css`);

class DocumentField extends Component {
  constructor(props){
    super(props)
    this.state = {
      file: {
        url: null,
        type: null,
        size: null,
        name: null,
        blob: null,
      }
    }
    this.handleOnChange = this.handleOnChange.bind(this)
    this.deleteFile = this.deleteFile.bind(this)
  }

  deleteFile(event){
    event.preventDefault();
    this.setState({
      ...this.state,
      file: {
        url: null,
        type: null,
        size: null,
        name: null,
        blob: null,
      }
    })
    this.props.onChange(null);
  }

  handleOnChange(value){
    this.setState({
        ...this.state,
        file:{
            url: URL.createObjectURL(value),
            type: value.type,
            size: value.size,
            name: value.name,
            blob: value
        }
    })
    this.props.onChange(value);
  }

  shortFileName(fileName){
    if(fileName.length > 50){
      return fileName.slice(0, 49) + '...'
    }else{
      return fileName
    }
  }

  render() {
    const { file } = { ...this.state };
    const { label } = { ...this.props };
    let imagePreviewStyle = {
      width: 'initial',
      height: 'initial',
    }
    if(file){
      if(file.width > file.height){
        imagePreviewStyle['maxWidth'] = '50px';
      }else{
        imagePreviewStyle['maxHeight'] = '50px';
      }
    }

  const cancelButton = (<div onClick={this.deleteFile}>
                          <span className="glyphicon glyphicon-remove" aria-hidden="true"></span>
                        </div>);

  const labelDiv = label && (<Col className="terms_col terms_checkbox pd-vcenter" xs={12} md={12} lg={12}><span>{this.props.label}</span></Col>);

  let actionButton;
  if(this.props.updating){
    actionButton = (<div>
                      <i className="fa fa-refresh fa-spin fa-lg fa-fw"></i>
                    </div>);
  }else if(file.blob){
    actionButton = cancelButton;
  }else{
    actionButton = (<FileField onChange={this.handleOnChange}/>);
  }

  let description = (<Row className="terms_row">
                      {labelDiv}
                      <Col className="terms_col pd-vcenter text-center" xs={12} md={12} lg={12}>
                          {actionButton}
                      </Col>
                    </Row>);
  if (file.blob){
    let imageRepresetation = (
    <div className={'summit-document-file file'}>
      <div className={'file-type file'}>
        file
      </div>
    </div>);

    if (file.type.search("image/") > -1){
      imageRepresetation = (<img className={'summit-image-file'} src={file.url} key={file.url} ></img>);
    }
    if (file.type.search("/pdf") > -1){
      imageRepresetation = (
      <div className={'summit-document-file pdf'}>
        <div className={'file-type file'}>
          pdf
        </div>
      </div>);
    }
    if (file.type.search("application/vnd.ms-excel") > -1 || file.type.search("text/csv") >  -1) {
      imageRepresetation = (
        <div className={'summit-document-file excel'}>
          <div className={'file-type file'}>
            {file.type.search("application/vnd.ms-excel") > -1 && 'excel'}
            {file.type.search("text/csv") > -1 && 'csv'}
          </div>
        </div>);
    }

    description =   (<Row className="terms_row">
                      {labelDiv}
                      <Col className="terms_col pd-vcenter text-center" xs={12} md={12} lg={12}>
                          {imageRepresetation}
                      </Col>
                      <Row>
                        <Col className="terms_col col-md-offset-3 col-xs-offset-3 col-lg-offset-3 summit-file-name" xs={5} md={5} lg={5}>
                            <span>{file.name}</span>
                        </Col>
                        <Col className="terms_col" xs={1} md={1} lg={1}>
                          <div className="btn-group" role="group" >
                            {actionButton}
                          </div>
                        </Col>
                      </Row>
                    </Row>);
  }


    return description;
  }
}
module.exports = DocumentField


/** WEBPACK FOOTER **
 ** ./src/components/DocumentField.js
 **/